module.exports = __webpack_public_path__ + "static/media/gunz-logo.b1c75afc.png";